// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map_container {
  padding-bottom: 5vh;
}

.map_details {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  line-height: 150% !important;
  font-size: 1.9vw;
  color: #fff;
  margin-top: 2.75vh;
}

.mapLinks {
  color: #fff;
  text-decoration: none;
  line-height: 150%;
  font-size: 1.5vw;
}

.mapLinks:hover {
  color: #f0592a;
}

.iconColor1 {
  font-size: 3.5vh;
  color: #f0592a !important;
  display: flex;
  align-items: center;
}

.iconColor2 {
  font-size: 3.5vh;
  color: #f0592a !important;
  display: flex;
  align-items: center;
}

.iconColor3 {
  font-size: 3.5vh;
  color: #f0592a !important;
  display: flex;
  align-items: center;
}

.locationImage {
  width: 3.5vh;
  height: auto;
  max-width: 100%;
}

.ant-image .ant-image-img .imageAllign {
  vertical-align: top;
}

.countryFont {
  font-size: 2vw;
}

.stateFont {
  font-size: 1.8vw;
}

.mapIamge {
  height: 30vh;
  border-radius: 1.3020833333vw;
}

@media (max-width: 1200px) {
  .countryFont {
    font-size: 2vw;
  }
  .stateFont {
    font-size: 1.8vw;
  }
}
@media (max-width: 992px) {
  .countryFont {
    font-size: 2vw;
  }
  .stateFont {
    font-size: 1.8vw;
  }
}
@media (max-width: 768px) {
  .countryFont {
    font-size: 3vw;
  }
  .stateFont {
    font-size: 2vw;
  }
  .mapLinks {
    font-size: 2.2vw;
  }
  .iconColor {
    font-size: 2.5vw;
  }
}
@media (max-width: 576px) {
  .countryFont {
    font-size: 5vw;
  }
  .stateFont {
    font-size: 4vw;
  }
  .mapLinks {
    font-size: 3.5vw;
  }
  .iconColor {
    font-size: 4vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Maps/Maps.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AACA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAEF;;AACA;EACE,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AAEF;;AACA;EACE,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AAEF;;AACA;EACE,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AAEF;;AACA;EACE,YAAA;EACA,YAAA;EACA,eAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,YAAA;EACA,6BAAA;AAEF;;AACA;EACE;IACE,cAAA;EAEF;EACA;IACE,gBAAA;EACF;AACF;AACA;EACE;IACE,cAAA;EACF;EAEA;IACE,gBAAA;EAAF;AACF;AAEA;EACE;IACE,cAAA;EAAF;EAGA;IACE,cAAA;EADF;EAIA;IACE,gBAAA;EAFF;EAKA;IACE,gBAAA;EAHF;AACF;AAKA;EACE;IACE,cAAA;EAHF;EAMA;IACE,cAAA;EAJF;EAOA;IACE,gBAAA;EALF;EAOA;IACE,cAAA;EALF;AACF","sourcesContent":[".map_container {\n  padding-bottom:  5vh;\n}\n.map_details {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150% !important;\n  font-size: 1.9vw;\n  color: #fff;\n  margin-top: 2.75vh;\n}\n\n.mapLinks {\n  color: #fff;\n  text-decoration: none;\n  line-height: 150%;\n  font-size: 1.5vw;\n}\n\n.mapLinks:hover {\n  color: #f0592a;\n}\n\n.iconColor1 {\n  font-size: 3.5vh;\n  color: #f0592a !important;\n  display: flex;\n  align-items: center;\n}\n\n.iconColor2 {\n  font-size: 3.5vh;\n  color: #f0592a !important;\n  display: flex;\n  align-items: center;\n}\n\n.iconColor3 {\n  font-size: 3.5vh;\n  color: #f0592a !important;\n  display: flex;\n  align-items: center;\n}\n\n.locationImage {\n  width: 3.5vh;\n  height: auto;\n  max-width: 100%;\n}\n\n.ant-image .ant-image-img .imageAllign {\n  vertical-align: top;\n}\n\n.countryFont {\n  font-size: 2vw;\n}\n\n.stateFont {\n  font-size: 1.8vw;\n}\n\n.mapIamge {\n  height: 30vh;\n  border-radius: 1.3020833333333333vw;\n}\n\n@media (max-width: 1200px) {\n  .countryFont {\n    font-size: 2vw;\n  }\n\n  .stateFont {\n    font-size: 1.8vw;\n  }\n}\n@media (max-width: 992px) {\n  .countryFont {\n    font-size: 2vw;\n  }\n\n  .stateFont {\n    font-size: 1.8vw;\n  }\n}\n@media (max-width: 768px) {\n  .countryFont {\n    font-size: 3vw;\n  }\n\n  .stateFont {\n    font-size: 2vw;\n  }\n\n  .mapLinks {\n    font-size: 2.2vw;\n  }\n\n  .iconColor {\n    font-size: 2.5vw;\n  }\n}\n@media (max-width: 576px) {\n  .countryFont {\n    font-size: 5vw;\n  }\n\n  .stateFont {\n    font-size: 4vw;\n  }\n\n  .mapLinks {\n    font-size: 3.5vw;\n  }\n  .iconColor {\n    font-size: 4vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
